import { useMemo, useState } from 'react';
import { useOrchestratorList } from '../../hooks/useOrchestratorList';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from 'recharts';
import { RejectedChartTable } from '../RejectedChartTable/RejectedChartTable';

export const RejectedChart = () => {
  const { orchestrators } = useOrchestratorList();
  const [selectedReasonKey, setSelectedReasonKey] = useState<string | null>(
    null
  );

  const data = useMemo(() => {
    const counts: Record<string, number> = {};
    orchestrators.data?.forEach(o => {
      o.workflow_steps.forEach(ws => {
        ws.responses.forEach(r => {
          if (r.status === 'REJECTED' && r.reason_for_discard) {
            let aux = '';

            switch (ws.name) {
              case 'idm revision de documentos':
                aux = 'docs';
                break;
              case 'idm pricing manual':
                aux = 'pricing';
                break;
              default:
                aux = ws.name;
                break;
            }

            const key = `${aux}: ${r.reason_for_discard.label}`;
            counts[key] = (counts[key] ?? 0) + 1;
          }
        });
      });
    });
    return Object.entries(counts).map(([name, count]) => ({ name, count }));
  }, [orchestrators.data]);

  const handleBarClick = (data: any) => {
    if (data && data.name) {
      if (selectedReasonKey === data.name) {
        setSelectedReasonKey(null);
      } else {
        setSelectedReasonKey(data.name);
      }
    }
  };

  if (data.length === 0) return <div>No hay datos</div>;

  return (
    <div data-testid="rejected-chart">
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={data}
          layout="vertical" // ← barras horizontales
          margin={{ top: 20, right: 30, left: 220, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis // keys (name)
            dataKey="name"
            type="category"
            width={220} // espacio para mostrar el texto completo
          />
          <Tooltip />
          <Bar
            dataKey="count"
            fill="#8884d8"
            onClick={handleBarClick}
            style={{ cursor: 'pointer' }}
          />
        </BarChart>
      </ResponsiveContainer>
      <RejectedChartTable
        selectedReasonKey={selectedReasonKey}
        onResetSelection={() => setSelectedReasonKey(null)}
      />
    </div>
  );
};
